import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Symbol } from "../GameComponents/Symbol";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { PlayList } from "../Components/Sounds/PlayList";
import { Payline } from "../GameComponents/Payline";
import { TimelineElement } from "../Components/Elements/Graphics/TimelineElement";
import { BetManager } from "../Managers/BetManager";
import { AppContext } from "../../Common/AppContext";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { GameManager } from "../Managers/GameManager";
import { Symbols } from "../GameComponents/Symbols";
import { Paylines } from "../GameComponents/Paylines";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator2 extends WinAnimator {
    //******************************************************************************************************************
    //  TIMER STATUSES
    //******************************************************************************************************************

    protected static readonly StartAnimation: string = "startAnimation";
    protected static readonly StartMysteryAnimation: string = "startMysteryAnimation";

    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private _animationMysteryNames: Array<string>;
    private _animationsMystery: Array<TimelineElement>;

    private _currentMysteryAnimationIndex: number;
    private _currentMysteryAnimationFinished: boolean = false;

    configure(node: Element): void {
        super.configure(node);

        if (node.hasAttribute("MysteryWinsAnimations")) {
            this._animationMysteryNames = node.getAttribute("MysteryWinsAnimations").split(";");
        }
    }

    public initialize(
        symbols: Symbols,
        paylines?: Paylines,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
    ): void {
        super.initialize(symbols, paylines, noWinSymbolsContainer, symbolsContainer);
        this.createMysteryAnimations();
    }

    protected createMysteryAnimations(): void {
        this._animationsMystery = [];

        if (this._animationMysteryNames != null) {
            for (let i: number = 0; i < this._animationMysteryNames.length; i++) {
                if (this.childs[this._animationMysteryNames[i]] != null) {
                    let animation = this.childs[this._animationMysteryNames[i]];
                    animation.visible = false;
                    animation.on("finished", this.onMysteryAnimationFinished.bind(this));
                    animation.on(TimelineElement.AnimationComplete, this.onMysteryAnimationComplete.bind(this));

                    this._animationsMystery.push(animation);
                } else {
                    if (DEBUG) {
                        this.log("ERROR no mystery high wins with name " + this._animationMysteryNames[i]);
                    }
                }
            }
        }

        this._currentMysteryAnimationIndex = null;
        this._currentMysteryAnimationFinished = true;
    }

    private onMysteryAnimationFinished(): void {
        this._currentMysteryAnimationFinished = true;

        this.emit(WinAnimator.FinishWinCalculation);
    }

    /**
     * Finish high win animations and start cycle win animations.
     * @method onMysteryAnimationComplete
     * @return void
     */
    private onMysteryAnimationComplete(): void {
        this._currentMysteryAnimationIndex = null;
        this.currentMultiplierIndex = -1;

        this.finishFirstWins();
    }

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        super.onReelStopped(reelsData, reelIndex);

        this.impactSpecialSymbols(reelsData, reelIndex);
    }

    private impactSpecialSymbols(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        let isScatterImpact: boolean = this.impactScatters(reelsData, reelIndex);
        if (reelIndex == 0 || (reelIndex > 0 && !isScatterImpact)) {
            this.impactWilds(reelsData, reelIndex);
        }
    }

    private impactScatters(reelsData: Array<Communication.Game.IReel>, reelIndex: number): boolean {
        let canImpact: boolean = true;
        let count: number = this.calculatePreviousScatters(reelsData, reelIndex, 8);

        if (reelIndex === 0) {
            if (count < 1) {
                canImpact = false;
            }
        } else if (reelIndex === 1) {
            if (count < 2) {
                canImpact = false;
            }
        } else if (reelIndex === 2) {
            if (count < 3) {
                canImpact = false;
            }
        }

        if (canImpact) {
            for (let i = 0; i <= reelIndex; i++) {
                if (reelsData[i] != null && reelsData[i].symbols != null) {
                    for (let j: number = 0; j < reelsData[i].symbols.length; j++) {
                        if (reelsData[i].symbols[j] === 8 && this.currentSymbols[i][j] != null && reelIndex == i) {
                            this.currentSymbols[i][j].goToCase(Symbol.CaseImpact);
                            PlayList.play("SND_BaseScatter");
                        } else {
                            if (reelIndex != 0 && reelsData[i].symbols[j] !== 8) {
                                this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                            }
                        }
                    }
                }
            }
        } else {
            for (let i = 0; i <= reelIndex; i++) {
                for (let j: number = 0; j < reelsData[i].symbols.length; j++) {
                    if (reelsData[i].symbols[j] !== 8) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                    }
                }
            }
        }

        return canImpact;
    }

    private impactWilds(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        if (reelsData[reelIndex] != null && reelsData[reelIndex].symbols != null) {
            for (let i: number = 0; i < reelsData[reelIndex].symbols.length; i++) {
                if (reelsData[reelIndex].symbols[i] === 7 && this.currentSymbols[reelIndex][i] != null) {
                    this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseImpact);
                    PlayList.play("SND_BaseWild");
                }
            }
        }
    }

    private calculatePreviousScatters(
        reelsData: Array<Communication.Game.IReel>,
        reelIndex: number,
        symbolId: number,
    ): number {
        let count: number = 0;
        for (let j: number = 0; j <= reelIndex; j++) {
            if (reelsData[j] != null && reelsData[j].symbols != null) {
                for (let i: number = 0; i < reelsData[j].symbols.length; i++) {
                    if (reelsData[j].symbols[i] === symbolId) {
                        count++;
                    }
                }
            }
        }

        return count;
    }

    protected showCustomWin(): boolean {
        let mysteryWin: Communication.Game.IWin = GameManager.baseResponse.wins
            .filter((win: Communication.Game.IWin) => win.type.toString() == "mystery")
            .pop();
        if (mysteryWin != null) {
            this.allPaylinesGoToCase(Payline.CaseNowin);

            let allWinSymbols: Array<Symbol> = [];
            for (let i = 0; i < this.currentWins.length; i++) {
                this.winPaylineGoToCase(i, Payline.CaseNormal);

                const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                    this.currentWins[i].paylineId,
                    this.paylines.paylineDefinition,
                );
                for (let i = 0; i < definition.length; i++) {
                    if (mysteryWin.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], Symbol.CaseWin)) {
                        const symbol = this.currentSymbols[i][definition[i]];
                        if (allWinSymbols.indexOf(symbol) < 0) {
                            allWinSymbols.push(symbol);
                        }
                    }
                }
            }

            this.currentSymbols.forEach((reel, reelIndex) => {
                reel.forEach((symbol, symbolIndex) => {
                    if (allWinSymbols.indexOf(symbol) < 0) {
                        symbol.goToCase(Symbol.CaseNowin);
                    } else {
                        symbol.goToCase(Symbol.CaseWin);
                    }
                });
            });

            allWinSymbols.length = 0;

            this.allPaylinesGoToCase(Payline.CaseWin);

            this.startTimer(WinAnimator2.StartMysteryAnimation, 30);

            return true;
        }

        return false;
    }

    protected resetMysteryAnimations(): void {
        this._currentMysteryAnimationIndex = null;
        this._currentMysteryAnimationFinished = true;

        for (let i = 0; i < this._animationsMystery.length; i++) {
            const animation = this._animationsMystery[i];
            animation.visible = false;
            animation.stop();
        }
    }

    protected startMysteryAnimation(): void {
        this._currentMysteryAnimationIndex = this.getAnimationIndex();
        this._currentMysteryAnimationFinished = false;

        const animation = this._animationsMystery[this._currentMysteryAnimationIndex];
        animation.visible = true;
        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            animation.play(parseInt(NumberUtils.devide(this.currentWin, BetManager.CoinSize).toString()));
        } else {
            ImageTextCounterElement.Round = false;
            animation.play(this.currentWin);
        }
    }

    protected stopMysteryAnimation(): void {
        if (this._currentMysteryAnimationIndex != null) {
            const animation = this._animationsMystery[this._currentMysteryAnimationIndex];
            animation.visible = true;
            if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
                ImageTextCounterElement.Round = true;
                animation.goToOutro(parseInt(NumberUtils.devide(this.currentWin, BetManager.CoinSize).toString()));
            } else {
                ImageTextCounterElement.Round = false;
                animation.goToOutro(this.currentWin);
            }

            this._currentMysteryAnimationIndex = null;
            this._currentMysteryAnimationFinished = true;
        }
    }

    protected showFirstWins(): void {
        this.allSymbolsGoToCase(Symbol.CaseNowin, true);
        this.allPaylinesGoToCase(Payline.CaseNowin);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            this.winPaylineGoToCase(i, Payline.CaseFirstWin);
        }

        PlayList.play("SND_BaseWinline");

        this.startTimer(WinAnimator2.StartAnimation, 15);
    }

    public reset(showLastSymbols: boolean): boolean {
        this.stopTimer();

        this.allSymbolsGoToCase(showLastSymbols ? Symbol.CaseNormal : Symbol.CaseEmpty, false);
        this.allPaylinesGoToCase(Payline.CaseNormal);

        this.paylines.showPaylinesLabel();

        if (showLastSymbols) {
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
        }

        this.value.stop();
        this.value.visible = false;

        let lastMultiplierIndex = this.currentMultiplierIndex;
        this.currentMultiplierIndex = -1;

        if (this.currentAnimationIndex != null) {
            if (this.currentAnimationFinished) {
                this.resetAnimations();

                this.currentWins = null;
                this.currentWin = null;
                return false;
            } else {
                this.stopAnimation();

                this.currentWins = null;
                this.currentWin = null;
                return lastMultiplierIndex >= 3;
            }
        } else {
            if (this._currentMysteryAnimationIndex != null) {
                if (this._currentMysteryAnimationFinished) {
                    this.resetMysteryAnimations();

                    this.currentWins = null;
                    this.currentWin = null;
                    return false;
                } else {
                    this.stopMysteryAnimation();

                    this.currentWins = null;
                    this.currentWin = null;
                    return lastMultiplierIndex >= 3;
                }
            }

            this.currentWins = null;
            this.currentWin = null;
            return lastMultiplierIndex >= 3;
        }
    }

    //******************************************************************************************************************
    //  TIMER
    //******************************************************************************************************************

    protected onTimerComplete(): void {
        super.onTimerComplete();

        switch (this.timerStatus) {
            case WinAnimator2.StartAnimation:
                this.startAnimation();
                break;
            case WinAnimator2.StartMysteryAnimation:
                this.startMysteryAnimation();
                break;
        }
    }

    protected finishFirstWins(): void {
        this.emit(WinAnimator.FinishWinAnimator);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);
        }

        this.currentCycle = 0;

        this.cycleWins();
    }

    protected allowSymbolGoToCase(reelIndex: number, symbolIndex: number, caseType: string): boolean {
        if (
            (this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle ||
                this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle + "_2" ||
                this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle + "_3") &&
            caseType === Symbol.CaseNormal
        ) {
            return false;
        }

        return true;
    }

    protected getIdleDelay(): number {
        return 30;
    }

    protected getInitialIdleDelay(): number {
        return 30;
    }

    protected getIdleActiveElementsCount(): number {
        return 2;
    }

    protected onAnimationFinished(): void {
        this._currentMysteryAnimationFinished = true;
        super.onAnimationFinished();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator2.ts
 **/